import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Layout } from "@/components/layout/Layout";
import { Home } from "@/pages/Home";
import { About } from "@/pages/About";
import { USP } from "@/pages/USP";
import { Investor } from "@/pages/Investor";
import { Franchise } from "@/pages/Franchise";
import { Technology } from "@/pages/Technology";
import { Contact } from "@/pages/Contact";
import { Admin } from "@/pages/Admin";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route element={<Layout />}>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/usp" element={<USP />} />
                        <Route path="/investor" element={<Investor />} />
                        <Route path="/franchise" element={<Franchise />} />
                        <Route path="/technology" element={<Technology />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/admin" element={<Admin />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
